<template>
  <svg 
    :width="size" 
    :height="size" 
    viewBox="0 0 24 24" 
    fill="currentColor"
    class="call-center-icon"
  >
    <!-- MDI-style headset operator icon -->
    <!-- Headset arc -->
    <path d="M12 1C7 1 3 5 3 10V17C3 18.66 4.34 20 6 20H9V12H5V10C5 6.13 8.13 3 12 3S19 6.13 19 10V12H15V20H18C19.66 20 21 18.66 21 17V10C21 5 17 1 12 1M7 14V18H6C5.45 18 5 17.55 5 17V14H7M19 17C19 17.55 18.55 18 18 18H17V14H19V17Z"/>
    <!-- Microphone -->
    <path d="M12 14C13.1 14 14 13.1 14 12H10C10 13.1 10.9 14 12 14M12 16C10.34 16 9 14.66 9 13H7C7 15.76 9.24 18 12 18S17 15.76 17 13H15C15 14.66 13.66 16 12 16Z"/>
  </svg>
</template>

<script setup>
defineProps({
  size: {
    type: [Number, String],
    default: 24
  }
})
</script>

<style scoped>
.call-center-icon {
  display: inline-block;
  vertical-align: middle;
}
</style>
